import { render, staticRenderFns } from "./PhoneLogin.vue?vue&type=template&id=259fa9bc&scoped=true&"
import script from "./PhoneLogin.vue?vue&type=script&lang=js&"
export * from "./PhoneLogin.vue?vue&type=script&lang=js&"
import style0 from "./PhoneLogin.vue?vue&type=style&index=0&id=259fa9bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259fa9bc",
  null
  
)

export default component.exports